module.exports = __webpack_public_path__ + "img/yanbao1.ef52e4b5.png";